import axios from 'axios';
import { withFreshAuth } from './freshAuth';
import { ENDPOINTS } from '../config/endpoints';

const AUTH_API = ENDPOINTS.auth;

const api = axios.create({ baseURL: AUTH_API });
api.interceptors.request.use(withFreshAuth);

export const promptService = {
  async list() {
    const { data } = await api.get('/prompts');
    return data.prompts;
  },

  async create(name, text) {
    const { data } = await api.post('/prompts', { name, text });
    return data;
  },

  async clone(promptId) {
    const { data } = await api.post('/prompts/' + promptId + '/clone');
    return data;
  },

  async update(promptId, fields) {
    const { data } = await api.patch('/prompts/' + promptId, fields);
    return data;
  },

  async remove(promptId) {
    const { data } = await api.delete('/prompts/' + promptId);
    return data;
  },

  async getSettings() {
    const { data } = await api.get('/me/settings');
    return data;
  },

  async updateSettings(fields) {
    const { data } = await api.patch('/me/settings', fields);
    return data;
  },
};
